import React, { useState, useEffect, useMemo } from 'react'
import { Auth } from 'aws-amplify';
import { useSearchParams } from 'react-router-dom';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, View } from '@aws-amplify/ui-react';
import Loading from '../components/loading';
import Chatmessages from './chatmessages';
import Personalinsurancependingbanner from '../components/personalinsurancependingbanner';
import Reservationcancelclosependingbanner from '../components/reservationcancelclosependingbanner';
import Alerts from './alerts';

export default function Dashboard({
  showPersonalInsuranceBanner = true,
  showReservationCancelCloseBanner = true,
}) {
    const [is_loading, updateIsLoading] = React.useState(false);
    const [count, setCount] = useState(0);
    const [jwt, setJwt] = React.useState(false);
    const [searchParams] = useSearchParams();

    const selectedFleets = useMemo(() => {
      const raw = searchParams.get('fleets');
      if (!raw) return [];
      return raw.split(',').map((f) => f.trim()).filter(Boolean);
    }, [searchParams]);

    // Fleet selector is single-select today; use the first selected code for scoped home widgets.
    const fleetCode = selectedFleets[0] || null;
    
    async function fetchPageData() {
      updateIsLoading(true);
      try {
          let session = await Auth.currentSession()      
          let accessToken = await session.getAccessToken()
          let jwt = await accessToken.getJwtToken()
          setJwt(jwt)
      }
      catch (e) {
          //const res = {status:"Error retrieving User information - email us at info@joinago.com: "+toString(e)}
          //updateRes(res) 
      }
      updateIsLoading(false);
    }

    useEffect(() => {
      fetchPageData();
    },[count])




  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            {
                is_loading ? <Loading /> : 
                jwt === false ? <Loading /> :
                <Flex 
                    direction='column'
                >
                    <Personalinsurancependingbanner
                      enabled={showPersonalInsuranceBanner}
                      fleetCode={fleetCode}
                      refreshKey={count}
                    />
                    <Reservationcancelclosependingbanner
                      enabled={showReservationCancelCloseBanner}
                      fleetCode={fleetCode}
                      refreshKey={count}
                    />
                    <Alerts
                      userJwt={jwt}
                      refreshJwt={() => setCount(count + 1)}
                      fleetCodes={selectedFleets}
                    />
                    <Chatmessages userJwt={jwt} refreshJwt={() => setCount(count + 1)} />
                    {/*<Widgets userJwt={jwt} />*/}
                </Flex>
            }
        </View>
      </Flex>
  );
}
